var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#214ba5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.162 6.67C10.0593 6.67 9.97533 6.63733 9.91 6.572C9.84467 6.50667 9.812 6.42267 9.812 6.32V5.06C9.812 4.95733 9.84467 4.87333 9.91 4.808C9.97533 4.74267 10.0593 4.71 10.162 4.71H11.842C11.9447 4.71 12.0287 4.74267 12.094 4.808C12.1593 4.87333 12.192 4.95733 12.192 5.06V6.32C12.192 6.42267 12.1593 6.50667 12.094 6.572C12.0287 6.63733 11.9447 6.67 11.842 6.67H10.162ZM10.176 15C10.0733 15 9.98933 14.9673 9.924 14.902C9.85867 14.8367 9.826 14.7527 9.826 14.65V8.07C9.826 7.96733 9.85867 7.88333 9.924 7.818C9.98933 7.75267 10.0733 7.72 10.176 7.72H11.828C11.9307 7.72 12.0147 7.75267 12.08 7.818C12.1453 7.88333 12.178 7.96733 12.178 8.07V14.65C12.178 14.7433 12.1453 14.8273 12.08 14.902C12.0147 14.9673 11.9307 15 11.828 15H10.176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a3461dcf0bb6438bb953abab776796a6.svg";
export { ForwardRef as ReactComponent };